// Only added 4 variants for the sake of simplicity. I doubt we would need more but if we do we can add more.
export enum VariantName {
  original = 'original',
  variant_1 = 'variant_1',
  variant_2 = 'variant_2',
  variant_3 = 'variant_3',
}

export interface Experiment {
  name: string;
  id: string;
  variants: {
    name: VariantName;
    id: string;
    weight: number;
  }[];
}
